<template>
    <div class="alertas-section">
        <div class="alertas-content">
            <h2 class="alertas-title fuente-posm">
                Alertas que salvan relaciones.
            </h2>
            <p class="alertas-text fuente-nova">
                Cuando un cliente tiene una mala experiencia, los primeros minutos son cruciales. En ese momento crítico, nuestro sistema envía alertas instantáneas con toda la información del caso a tu equipo vía WhatsApp.
                <br><br>
                Tu equipo tiene la velocidad y los datos exactos para convertir un problema en una demostración de servicio excepcional.
            </p>
        </div>
        <div class="alertas-image">
            <img :src="a48" alt="Alertas">
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlertasFeedbackNew',
    data() {
        return {
            a48: require('@/assets/images/a47.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.alertas-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
    background-color: #272727;
}

.alertas-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.alertas-image img {
    width: 450px;
    height: auto;
}

.alertas-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.alertas-title {
    color: var(--color-5);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.alertas-text {
    color: var(--color-5);
    font-size: 27px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .alertas-title {
        font-size: 60px;
    }

    .alertas-text {
        font-size: 25px;
    }

    .alertas-image img {
        width: 350px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .alertas-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .alertas-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .alertas-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .alertas-image img {
        width: 90%;
        max-width: 350px;
    }

    .alertas-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .alertas-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
